import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppLayout } from "@/components/AppLayout";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import Validation from "@/pages/Validation";
import ValidationAgentPrompt from "@/pages/ValidationAgentPrompt";
import Review from "@/pages/Review";
import Jobs from "@/pages/Jobs";
import Scrapes from "@/pages/Scrapes";
import Viewer from "@/pages/products/Viewer";
import Featured from "@/pages/products/Featured";
import NvgSimulation from "@/pages/NvgSimulation";
import NvgContextual from "@/pages/NvgContextual";
import NvgCatalog from "@/pages/NvgCatalog";
import Overrides from "@/pages/Overrides";
import Capabilities from "@/pages/Capabilities";
import Sources from "@/pages/Sources";
import FeaturedSources from "@/pages/sources/FeaturedSources";
import Coupons from "@/pages/sources/Coupons";
import ExternalReviews from "@/pages/sources/ExternalReviews";
import SiteGate from "@/pages/SiteGate";
import EmailTesting from "@/pages/EmailTesting";
import Subscriptions from "@/pages/users/Subscriptions";
import DeletionRequests from "@/pages/users/DeletionRequests";
import CreateUser from "@/pages/users/CreateUser";
import AdminNewsletter from "@/pages/newsletter/AdminNewsletter";
import BusinessAccounts from "@/pages/businesses/BusinessAccounts";

export const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    ),
    children: [
      {
        path: "/auth",
        element: <Auth />,
      },
      {
        path: "/",
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/review" replace /> },
          { path: "review", element: <Review /> },
          { path: "validation", element: <Validation /> },
          {
            path: "validation/agent-prompt",
            element: <ValidationAgentPrompt />,
          },
          { path: "jobs", element: <Jobs /> },
          { path: "scrapes", element: <Scrapes /> },
          {
            path: "sources",
            element: <Navigate to="/sources/config" replace />,
          },
          { path: "sources/config", element: <Sources /> },
          { path: "sources/featured", element: <FeaturedSources /> },
          { path: "sources/coupons", element: <Coupons /> },
          { path: "sources/external-reviews", element: <ExternalReviews /> },
          { path: "products/viewer", element: <Viewer /> },
          { path: "products/featured", element: <Featured /> },
          {
            path: "product-viewer",
            element: <Navigate to="/products/viewer" replace />,
          },
          { path: "simulation", element: <NvgSimulation /> },
          { path: "contextual-sim", element: <NvgContextual /> },
          { path: "catalog-runs", element: <NvgCatalog /> },
          { path: "overrides", element: <Overrides /> },
          { path: "capabilities", element: <Capabilities /> },
          { path: "site-gate", element: <SiteGate /> },
          { path: "email-testing", element: <EmailTesting /> },
          {
            path: "users",
            element: <Navigate to="/users/subscriptions" replace />,
          },
          { path: "users/subscriptions", element: <Subscriptions /> },
          { path: "users/deletion-requests", element: <DeletionRequests /> },
          { path: "users/create", element: <CreateUser /> },
          { path: "businesses", element: <BusinessAccounts /> },
          { path: "newsletter", element: <AdminNewsletter /> },
          { path: "home", element: <Home /> },
        ],
      },
    ],
  },
]);
